<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title"> Zone Scan Pro Master List</h1>
        </div>
        <div class="col-sm-6 float-left add_user_btn">
            <a routerLink="/create-zone-scanpro-master" class="btn btn-success">
                <i class="fa fa-plus" aria-hidden="true"></i> Add Zone Scan Pro
            </a>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-2">
                        <mat-select (selectionChange)="getCircleZone($event.value)" placeholder="Circle"
                            [(ngModel)]="circle" (click)="setSearchValue('circle')">
                            <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="circleSearch">
                            <mat-option>All</mat-option>
                            <mat-option [value]="cir.id" *ngFor="let cir of circles">{{cir.name}}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2">
                        <mat-select placeholder="Zone" [(ngModel)]="zone" [disabled]="circle_zone">
                            <mat-option>Select Zone</mat-option>
                            <mat-option [value]="zone.id" *ngFor="let zone of zones">
                                {{zone.zone_name}}
                            </mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-2">
                        <mat-select placeholder="Scan Pro User" [(ngModel)]="scanpro">
                            <input class="mySearchInput" #scanproSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'scanpro')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="scanproSearch">
                            <mat-option [value]="scanpro.id" *ngFor="let scanpro of allscanproUser">
                                {{scanpro.name}}
                            </mat-option>
                        </mat-select>
                    </div>
                    <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadScanProList(0,perpage)">
                        <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                    <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                            class="fa fa-sync"></i> Reset Filters</button>

                </div>

            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadScanProList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button>
                    <button type="button" class="btn btn-success ml-2" [disabled]="loading"
                        (click)="exportZoneScanProList()"><i class="fa fa-file-excel"></i> Export List</button>
                </div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 50px;">#</th>
                            <th>Circle</th>
                            <th>Zone</th>
                            <th>Scan Pro User</th>
                            <th style="width: 100px;">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let scanpro of scanProList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{scanpro.circle_name}} </td>
                            <td>{{scanpro.zoneName}} </td>
                            <td>{{scanpro.scanpro_user}} </td>
                            <td>
                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Action
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item"
                                            routerLink="/update-zone-scanpro-master/{{scanpro.id}}"><i
                                                class="fa fa-pen"></i> Update</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="5" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !scanProList.length">
                            <td colspan="5"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>